<template>
  <div class="card">
    <Form @submit="onSubmit" :validation-schema="schema">
      <div class="card-header">
        <h4 class="card-title">Data | Create</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <SelectInput
            :value="data.namespace"
            name="namespace"
            :options="namespaces"
            label="Namespace"
            placeholder="--- Select Namespace ---"
            success-message="Good!"
          />

          <TextInput
            :value="data.code"
            name="code"
            type="text"
            label="Code"
            placeholder="Code"
            success-message="Good!"
          />

          <TextInput
            :value="data.year"
            name="year"
            type="number"
            label="Year"
            placeholder="Year"
            success-message="Good!"
          />

          <SelectInput
            :value="data.type"
            name="type"
            :options="types"
            label="Type"
            placeholder="--- Select Type ---"
            success-message="Good!"
          />

          <TextInput
            :value="data.make"
            name="make"
            type="text"
            label="Make"
            placeholder="Make"
            success-message="Good!"
          />

          <TextInput
            :value="data.model"
            name="model"
            type="text"
            label="Model"
            placeholder="Model"
            success-message="Good!"
          />

          <TextInput
            :value="data.model_type"
            name="model_type"
            type="text"
            label="Model Type"
            placeholder="Model Type"
            success-message="Good!"
          />
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-xl-12">
            <div role="group" class="float-right btn-group">
              <button type="submit" class="btn btn-success btn-sm">Save</button>
            </div>
          </div>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import * as Yup from "yup";
import { createData } from "../../controllers/data-contoller";
import TextInput from "../../components/TextInput";
import { useRouter } from "vue-router";
import SelectInput from "../../components/SelectInput";
import { namespaceList, typeList } from "../../controllers/data-contoller";

export default {
  name: "DataCreate",
  components: {
    Form,
    TextInput,
    SelectInput,
  },
  async setup() {
    const router = useRouter();
    const data = {
      namespace: "",
      year: "",
      code: "",
      type: "",
      make: "",
      model: "",
      model_type: "",
    };

    async function onSubmit(values) {
      try {
        await createData(values);
        await router.push({ name: "DataList" });
      } catch (e) {
        alert("something went wrong");
      }
    }

    const schema = Yup.object().shape({
      code: Yup.string().required(),
      namespace: Yup.string().required(),
      type: Yup.string().required(),
      year: Yup.number().required(),
      make: Yup.string().required(),
      model: Yup.string().required(),
      model_type: Yup.string().required(),
    });

    return {
      onSubmit,
      schema,
      data,
    };
  },
  data: () => {
    return {
      namespaces: namespaceList,
      types: typeList,
    };
  },
};
</script>
